<script lang="ts">
    import { accessToken } from "../../../store"

    import Lightbox from "../Lightbox.svelte"

    export let filelist: Attachement[]
    // liest nur number/id/collectionName – beide Kollektionen sind zulässig
    export let operation: Operation | OperationOut
    export let operationType = "operation"

    let files: {
        [key: string]: Attachement
    }

    let file: Attachement
    let open = false

    $: {
        files = {}
        file = undefined
        if (filelist?.length) {
            for (let i = 0; i < filelist.length; i++) {
                let m = filelist[i].name.match(/\-([^\.\-]+)\.[^\.]+$/)
                if (m && !files[m[1]]) {
                    files[m[1]] = filelist[i]
                }
            }
        }
        if (files["2"]) {
            file = files["2"]
        } else {
            file = files["3"]
        }
    }
</script>

{#if file}
    <!-- svelte-ignore a11y-click-events-have-key-events -->

    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="attached_image"
        on:click|preventDefault|stopPropagation="{() => {
            open = true
        }}"
    >
        <img
            src="/api/attachement?{$accessToken
                ? 'accessToken=' + $accessToken + '&'
                : ''}pass=inline&r=s&op={operationType == 'operation'
                ? operation.number
                : operation.id}&f={file.name}&type={operation.collectionName}"
            alt=""
            width="120"
        />
        <div class="overlay">
            <span class="material-icons">search</span>
        </div>
    </div>

    <Lightbox
        bind:open
        imageUrl="/api/attachement?{$accessToken
            ? 'accessToken=' + $accessToken + '&'
            : ''}&pass=attachment&op={operationType == 'operation'
            ? operation.number
            : operation.id}&f={file.name}&type={operation.collectionName}"
        downloadUrl="/api/attachement?{$accessToken
            ? 'accessToken=' + $accessToken + '&'
            : ''}&pass=attachment&op={operationType == 'operation'
            ? operation.number
            : operation.id}&f={file.name}&type={operation.collectionName}"
    />
{/if}
